import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "ms-nested-nav-elm" }

import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'NestedNavElement',
  props: {
  name: String,
  href: String,
  isExpanded: Boolean
},
  emits: ['isActive'],
  setup(__props, { emit: __emit }) {

var props = __props

const emit = __emit

const route = useRoute()

const active = computed(() => {
  if (props.href === undefined || props.href === '/') {
    return route.path === '/'
  }

  var active = route.path.startsWith(props.href)

  return active
})

watch(
  () => active.value,
  (newVal) => {
    if (newVal) {
      emit('isActive', true)
    } else {
      emit('isActive', false)
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: __props.href ?? '',
    id: 'nav-row-' + __props.name
  }, {
    default: _withCtx(() => [
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item mt-1 nav-item-nested", __props.isExpanded ? ' justify-content-start' : 'd-flex flex-row justify-content-center'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([[
          'nav-link ms-nav ',
          __props.isExpanded ? 'justify-content-start' : 'justify-content-center ms-nav-sm'
        ], "d-flex flex-row rounded NKT-P2"]),
          id: 'nav-link-' + __props.name
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              class: _normalizeClass(['ms-nav-text', { expanded: __props.isExpanded }])
            }, _toDisplayString(__props.isExpanded ? __props.name : ''), 3)
          ])
        ], 10, _hoisted_1)
      ], 2)
    ]),
    _: 1
  }, 8, ["to", "id"]))
}
}

})